import CloseIcon from '@mui/icons-material/Close';
import { Box, Modal } from '@mui/material';
import styled from 'styled-components';
import { colors, fontSize } from '../../../theme';

export const CloseIconModalStyled = styled(CloseIcon)`
    && {
        position: absolute;
        right: 16px;
        top: 16px;
        cursor: pointer;
        padding: 8px;
        transition: color 400ms ease-in-out;
        &:hover {
            color: ${colors.grey100};
            transition: color 400ms ease-in-out;
        }
    }
`;

export const ModalStyled = styled(Modal)`
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
`;
export interface ExportGdprButtonStyledProps {
    bgColor: string
    bgColorHover: string
    fontColor: string
    hasBoxShadow: boolean
    marginLeft?: boolean
}

export const ExportGdprButtonStyled = styled(Box)((props : ExportGdprButtonStyledProps) => `
    display: inline-flex;
    padding: 10px 21px;
    justify-content: center;
    align-items: center;
    font-size: ${fontSize.m};
    width: auto;
    min-width: 120px;
    color: ${props.fontColor};
    border-radius: var(--RADIUS, 8px);
    background: ${props.bgColor};
    box-shadow: ${props.hasBoxShadow ? '0px 4px 4px 10px 0px rgba(20, 119, 130, 0.30)' : 'none'};
    &:hover {
        background-color: ${props.bgColorHover};
        cursor: ${'pointer'};
        transition: background-color 500ms ease-in-out;
    }
    float: right;
    ${props.marginLeft ? 'margin-left: auto!important;' : ''}
`);

export const ButtonsDiv = styled.div`
    display: flex;
    align-content: center;
    gap: 20px;
    margin-top: 30px;
    padding: 0px 10%;
`;
